export const ContentCopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
        <path
            fill="currentColor"
            d="M17 15h-5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h3.378a.5.5 0 0 1 .353.147l2.122 2.122a.502.502 0 0 1 .147.353V14a1 1 0 0 1-1 1Zm1.56-8.44-2.12-2.12A1.5 1.5 0 0 0 15.382 4H12c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2V7.622a1.5 1.5 0 0 0-.44-1.06V6.56ZM7 8c-1.103 0-2 .897-2 2v8c0 1.103.897 2 2 2h5c1.103 0 2-.897 2-2v-1h-1v1a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h2V8H7Z"
        />
    </svg>
);
